<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<!-- <app-search-component></app-search-component> -->


<div class=" container-flex alert text-white col-sm ml-3" style="background-color: #525966;"
  *ngIf="dcounts && dcounts?.length" role="alert">
  <div class="" *ngFor="let dam of dcounts">

    <p style="color:aliceblue;">Hi Admin {{name1}} {{name2}}
      <a [routerLink]="['/organisation-edit/' + dam.org_id]" class="pull-right"
        style="color: aliceblue;"><span>&#10003;</span>Update info</a>
    </p>

    <div class="row">
      <div class="text-center text-white">
        <h4> <i class="fa fa-hospital-o"></i><br />{{ dam.oname?dam.oname:'' }}</h4>
        <h5>{{ dam.address1?dam.address1+',':'' }} {{ dam.address2 ?dam.address2+',' :''}} </h5>
        <h5>{{ dam.city? dam.city: ''}} </h5>
      </div>
    </div>

  </div>
</div>

<div class="container-flex">

  <div class="row h-100 mt-3  ml-3">

    <div class="col-sm card dash-message mr-3 shade ">

      <div class="dash-message" *ngIf="!dcounts || !dcounts?.length">
        <div class="col-12 card-body ">
          <h5 class="card-title text-primary">
            Create Your Organisation Profile
          </h5>
          <p>
            <a routerLink="/info-basic" class="text-primary">Click Here</a> to
            complete the Registration Process
          </p>
        </div>
      </div>


      <div class="h-100 dash-message ">

        <h5 class="pt-3 card-title header-title heading-color">
          Today's Agenda
        </h5>


        <div class="row">
          <div class="col text-center">
            <div class="card shade">
              <i class="pt-2 fa fa-globe" style="color: royalblue;font-size: 32px;"></i>
              <div class="card-body ">
                <h5 class="card-text"><b>
                    {{a_dashboardvalues?.online_admin_request_count?a_dashboardvalues.online_admin_request_count:'0'}} /
                    {{a_dashboardvalues?.online_admin_schedule_count?a_dashboardvalues.online_admin_schedule_count:'0'}}
                  </b>
                </h5>
                <p class="card-text"><b> Request / Schedule</b></p>
              </div>
              <p class="card-text mb-3"><strong> Online</strong></p>
            </div>
          </div>

          <div class="col text-center">
            <div class="card shade">
              <i class="pt-2 	fas fa-person-booth" style="color: royalblue;font-size: 32px;"></i>
              <div class="card-body">
                <h5 class="card-text"><b>
                    {{a_dashboardvalues?.inperson_admin_schedule_count?a_dashboardvalues.inperson_admin_schedule_count:'0'}}
                    /
                    {{a_dashboardvalues?.inperson_admin_checkin_count?a_dashboardvalues.inperson_admin_checkin_count:'0'}}
                  </b></h5>
                <p class="card-text"><b>Schedule / Checkin</b></p>
              </div>
              <p class="card-text mb-3"><strong> In-person</strong></p>
            </div>
          </div>
        </div>


      </div><br />

    </div>

    <br />

    <div class="col-sm  card dash-message mr-3 shade" *ngIf="dcounts && dcounts?.length">

      <div class="h-100 dash-message " *ngFor="let dam of dcounts">

        <div class="d-none d-lg-block">
          <h5 class="pt-3  card-title header-title heading-color">Registrations
            <a [routerLink]="['/profile']" class="pull-right mr-1" style="cursor: pointer;font-size: small;">
              <span>&#10003;</span>Click here to Add New Profiles</a>
          </h5>
        </div>

        <div class="d-block d-lg-none">
          <h5 class="pt-3  card-title header-title heading-color">Registrations</h5>
          <p><a [routerLink]="['/profile']" style="cursor: pointer;">
              <span>&#10003;</span>Click here to Add New Profiles</a></p>
        </div>


        <div class="row text-center">
          <div class="col">
            <div class="card shade">
              <i class="fa fa-user-md pt-2" style="color: royalblue;font-size: 26px;"></i>
              <div class="card-body">
                <h5 class="card-title"><b>{{ dam.count }}</b></h5>
                <p class="card-text"><a [routerLink]="['/profile/search/physicians']"><strong>Doctors</strong></a>
                </p>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="card shade">
              <i class="fa fa-bed pt-2" style="color: goldenrod;font-size: 26px;"></i>
              <div class="card-body">
                <h5 class="card-title"> <b>{{ dam.patcount }}</b></h5>
                <p class="card-text"> <a [routerLink]="['/profile/search/patient']"><strong>Patients</strong></a></p>
              </div>
            </div>
          </div>
        </div>
        <br />

      </div>
    </div>


  </div>

  <br />

  <!-- Chart Display 1 . Appouintment   2.Earnings -->

  <div class="row   mb-3 ml-3">

    <div class="col-sm  h-100 card dash-message mr-3 shade ">

      <div class=" dash-message ">


        <h5 class="pt-3 card-title header-title heading-color">
          Appointments
        </h5>

        <div class="chart-container">
          <canvas id="MyChart">{{ chart }}</canvas>
        </div>


      </div>


    </div><br />


    <div class="col-sm   h-100 card dash-message mr-3 shade">

      <div class=" dash-message ">


        <h5 class="pt-3 card-title header-title heading-color">
          Earnings
        </h5>

        <div class="chart-container">
          <canvas id="MyChart1">{{ chart1 }}</canvas>
        </div>



      </div>


    </div>

  </div>



</div>

<br />
<div class="container-flex row ml-1">

  <div class="col" style="height: 400px; overflow: auto;">
    <table class="table align-middle mb-0 bg-white ">
      <thead class="bg-light">
        <tr>
          <th style="color: #2e60f2;">PHYSICIANS</th>
          <th>Contact No</th>
          <th>Status</th>
        </tr>
      </thead>
      <div *ngIf="users.length >0; else noRecords"></div>
      <tbody *ngFor="let dr of users">
        <tr>
          <td>
            <div class="d-flex align-items-center">
              <img src="{{dr?.ppurl}}" alt="" style="width: 45px; height: 45px" class="rounded-circle" />
              <div class="ms-3">
                <p class="fw-bold mb-1">{{dr?.title}} {{dr?.first_name}} {{dr?.last_name}} </p>
                <p class="text-muted mb-0">{{dr?.email_id}}</p>
              </div>
            </div>
          </td>
          <td>
            <p class="fw-normal mb-1">{{dr?.contact_no}}.</p>
          </td>
          <td *ngIf="dr?.consult_now=='false' || dr?.consult_now==null">
            <span class="badge badge-dark rounded-pill d-inline">Offline</span>
          </td>
          <td *ngIf="dr?.consult_now=='true'">
            <span class="badge badge-success rounded-pill d-inline">Online</span>
          </td>


        </tr>
      </tbody>
    </table>
    <ng-template #noRecords>
      <div class="text-dark">
        <br /><br />
        <center>No Physician found </center>
      </div>
    </ng-template>
  </div>


  <div class="col d-none d-md-block" style="height: 400px; overflow: auto;">
    <table class="table align-middle mb-0 bg-white">
      <thead class="bg-light">
        <tr>
          <th style="color: #2e60f2; letter-spacing: 0.02em; font-size: 15px;font-weight: 700;">FRONT DESK EXECUTIVES
          </th>
          <th>Contact No</th>
        </tr>
      </thead>
      <div *ngIf="fdeskusers.length >0; else noRecord"></div>
      <tbody *ngFor="let fd of fdeskusers">
        <tr>
          <td>
            <div class=" d-flex align-items-center">
              <img src="{{fd?.ppurl}}" alt="" style="width: 45px; height: 45px" class="rounded-circle" />
              <div class="ms-3">
                <p class="fw-bold mb-1">{{fd?.first_name}}{{fd?.last_name}}</p>
                <p class="text-muted mb-0">{{fd?.email_id}}</p>
              </div>
            </div>
          </td>
          <td>
            <p class="fw-normal mb-1">{{fd?.contact_no}}</p>

          </td>
        </tr>
      </tbody>

    </table>

    <ng-template #noRecord>
      <div class="text-dark">
        <br /><br />
        <center>No Executives found </center>
      </div>
    </ng-template>
  </div>

</div>


<!-- <div class="chart-container">
  <canvas id="MyChart">{{ chart }}</canvas>
</div>

<div class="chart-container">
  <canvas id="MyChart1">{{ chart1 }}</canvas>
</div> -->